(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"]) return;
  try {
    
if (!customElements.get('favela-signup')) {
  customElements.define('favela-signup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.bound) return;
      this.bound = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.key = 'favela-signup-dismissed-v1';
      this.editor = this.dataset.editor === 'true';
      this.steps = this.querySelectorAll('[data-step]');
      this.emailForm = this.querySelector('#FavelaSignupEmail');
      const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.closePopup(), options));
      this.dialog.addEventListener('cancel', () => this.rememberDismissal(), options);
      this.dialog.addEventListener('click', event => {
        const r = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) this.closePopup();
      }, options);
      this.emailForm.addEventListener('submit', event => {
        if (this.editor) { event.preventDefault(); this.showStep('success'); }
      }, options);
      document.addEventListener('shopify:section:select', event => { if (this.contains(event.target) || event.target.contains(this)) this.openPopup(); }, options);
      document.addEventListener('shopify:section:deselect', event => { if (this.contains(event.target) || event.target.contains(this)) this.dialog.close(); }, options);
      const emailResult = this.querySelector('[data-email-success]');
      if (emailResult.dataset.emailSuccess === 'true') {
        this.step = 'success'; this.rememberDismissal(); this.openPopup();
      } else if (emailResult.dataset.emailErrors === 'true') {
        this.step = 'email'; this.openPopup();
      } else if (this.editor) {
        this.step = this.dataset.previewStep || 'email'; this.openPopup();
      } else {
        this.step = 'email';
        if (Number(read(localStorage, this.key)) > Date.now()) return;
        this.timer = setTimeout(() => this.openPopup(), Number(this.dataset.delay || 5) * 1000);
      }
    }
    showStep(name) {
      this.step = name;
      this.steps.forEach(step => { step.hidden = step.dataset.step !== name; });
      const heading = this.querySelector('[data-step="' + name + '"] h2');
      if (heading) {
        heading.id = 'FavelaSignupTitle-' + name;
        this.dialog.setAttribute('aria-labelledby', heading.id);
        if (this.dialog.open) heading.focus({ preventScroll: true });
      }
    }
    openPopup() {
      this.showStep(this.step || 'email');
      if (!this.dialog.open) this.dialog.showModal();
    }
    rememberDismissal() {
      if (this.editor) return;
      try { localStorage.setItem(this.key, String(Date.now() + Number(this.dataset.days || 7) * 86400000)); } catch {}
    }
    closePopup() { this.rememberDismissal(); this.dialog.close(); }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.bound = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
